import React from 'react';
import '../Styles/AboutStyles.css';
import "../Styles/HomeStyles.css";
import AppHeader from '../Layout/Header';
import Comp1 from '../Components/HomeComponents/Component1';
import { Layout } from 'antd';
import GlanceComponent from '../Components/HomeComponents/GlanceComponent';
import LabsComponent from '../Components/HomeComponents/LabsComponent';
import ImpactSection from '../Components/HomeComponents/ImpactComponent';
import LinkagesOutreach from '../Components/HomeComponents/L&OComponent';
import ResearchFundComponent from '../Components/HomeComponents/ResearchFundComponent';
import FooterComponent from '../Layout/Footer';
import FooterQuote from '../Layout/FooterQuote';



const HomeScreen = () => {
    return (
        <Layout className="home-layout">
            <AppHeader />
            <main className="page-content-bands">
            <Comp1 />
            <GlanceComponent/>
            <LabsComponent/>
            <LinkagesOutreach/>
            <ResearchFundComponent/>
            <ImpactSection/>
            </main>
            <FooterQuote
              variant="home"
              quote="Indeed, in the creation of the heavens and the earth and the alternation of the night and the day are signs for those of understanding."
              attribution="Qur’an 3:190"
            />
            <FooterComponent/>
        </Layout>
    );
};

export default HomeScreen;
